import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { resolveDefinition } from '@angular/core/src/view/util';
import { CookieService } from 'ngx-cookie-service';


@Injectable()
export class AuthenticationService {
  cookieValue;

  constructor(private http: Http,private _router: Router, private cookieService: CookieService) { }

  logout() {
    localStorage.removeItem("Id");
    localStorage.removeItem("username");
    localStorage.removeItem("userrole");
   // localStorage.removeItem("openpages");
    //localStorage.removeItem("page_available");
    this.cookieService.delete('login');
    this._router.navigate(['Login']);
  }
 
  errorMsg : string;
  

  login(user: string, password: string){

//alert(user);
//alert(password);

    let url = 'webservice.php?action=userlogin&user='+user+'&pass='+password;  
    return this.http.get(url)
      .map(res => res.json())
      .subscribe(response => {
        //console.log(response);
        if(response.status == 'success'){
          localStorage.setItem("Id", response.result.Id);
          localStorage.setItem("username", response.result.user);
          localStorage.setItem("userrole", response.result.role);
         
          //localStorage.openpages = Date.now();
          //alert
          if(response.result.role == 1){
            this._router.navigate(['Farmer']);
          }
          if(response.result.role == 2){
                this._router.navigate(['Parent']);
              }
              if(response.result.role == 3){
                this._router.navigate(['Product-stock']);
              }  
        
              if(response.result.role == 4){
                this._router.navigate(['Parent']);
              }  

         // this._router.navigate(['Farmer']); 
          return true;
        }
        return false;
    
      }, //For Success Response  
      err => {
        console.error(err);
        alert('Something Wrong!!');
      } //For Error Response
    );
    
  }
 
   checkCredentials(){
    if (localStorage.getItem("Id") === null){
        this._router.navigate(['Login']);
    }
  
    this.cookieValue = this.cookieService.get('login');

    if(this.cookieValue != 'on'){
      localStorage.removeItem("Id");
      localStorage.removeItem("username");
      localStorage.removeItem("userrole");
      this.cookieService.delete('login');
      this._router.navigate(['Login']);
    }  

  //   let time:any =Date.now();
  //   localStorage.newpages = Date.now();
  //   var onLocalStorageEvent = function(e){
  //       if(localStorage.getItem("openpages")){
  //           // Listen if anybody else opening the same page!
  //           localStorage.page_available = Date.now();
  //       }
  //       if(e.key == "page_available"){
  //          // alert("One more page already open");
  //       }
   
  //      //console.log(e.key);
  //  };
  //   window.addEventListener('storage', onLocalStorageEvent, false);

  
    
    // if (localStorage.getItem("Id") != null){
    //   if(localStorage.getItem("userrole") == '1'){
    //    // this._router.navigate(['Farmer']);
    //   }
    //   if(localStorage.getItem("userrole") == '2'){
    //    // this._router.navigate(['Parent']);
    //   }
    //   if(localStorage.getItem("userrole") == '3'){
    //    // this._router.navigate(['Product-stock']);
    //   }  

    //   if(localStorage.getItem("userrole") == '4'){
    //    // this._router.navigate(['Parent']);
    //   }  
    //  }


  }

}
